import request from '@/utils/request'

// 查询维修分类列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/category/page',
        method: 'get',
        params: query,
    })
}
// 查询维修分类列表分页
export function categoryList(query) {
    return request({
        url: '/upkeep/category/page',
        method: 'get',
        params: query,
    })
}
// 查询维修分类详细
export function getObj(id) {
    return request({
        url: '/upkeep/category/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修分类
export function addObj(data) {
    return request({
        url: '/upkeep/category/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用状态
export function statusObj(data) {
    return request({
        url: '/upkeep/category/status',
        method: 'post',
        data: data,
    })
}
// 修改维修分类
export function putObj(data) {
    return request({
        url: '/upkeep/category/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修分类
export function delObj(data) {
    return request({
        url: '/upkeep/category/delete',
        method: 'post',
        data: data,
    })
}
